export const SWISS_INDEX_DB = 'SwissSoftDB';
export const SWISS_SERVICES = 'SwissServices';
export const SWISS_WEB_CONFIG_DB_NAME = 'SwissWebConfigDB';
export const SWISS_SERVICE_APP_DOCUMENT_STORE_NAME = 'ServiceAppDB_Doku';
export const SWISS_SERVICE_APP_DB_STORE_NAME = 'ServiceAppDB';
export const SWISS_DOCUMENT_SYNC_QUEUE = 'DocumentSynchronisationQueue';
